var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFuncaoSoma(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-soma",
    transform: "translate(-174 -862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2181",
    "data-name": "Grupo 2181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2180",
    "data-name": "Grupo 2180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2179",
    "data-name": "Grupo 2179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2178",
    "data-name": "Grupo 2178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sum-sign",
    transform: "translate(148.672 867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1202",
    "data-name": "Caminho 1202",
    d: "M63.29,8.028V4.579H40.874L54.064,18.766a2.291,2.291,0,0,1-.026,3.146L41,35.476H63.29V33.393a2.29,2.29,0,0,1,4.579,0v4.372a2.293,2.293,0,0,1-2.29,2.29H35.619a2.29,2.29,0,0,1-1.651-3.876L49.237,20.3l-15.3-16.45A2.29,2.29,0,0,1,35.619,0H65.58a2.293,2.293,0,0,1,2.29,2.29V8.028a2.29,2.29,0,0,1-4.579,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_440",
    "data-name": "Ret\\xE2ngulo 440",
    width: 50,
    height: 50,
    transform: "translate(174 862)",
    fill: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoSoma);
export default __webpack_public_path__ + "static/media/ico-funcao-soma.d8ab3ec7e7fa0fa0511718efc90763ae.svg";
export { ForwardRef as ReactComponent };